'use client';

import { buttonClasses, buttonGroupClasses, styled } from '@mui/material';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import PlaceIcon from '@mui/icons-material/Place';
import useSearchStore from '@/studbook/store/useSearchStore';
import { blue } from '@/lib/colours';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import { Button, ButtonGroup } from '@/primitives';

const ResultToolbarButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  border: '1px !important',
  [`&.${buttonClasses.disabled}`]: {
    border: '1px !important',
  },
}));

const ResultToolbarButtonGroup = styled(ButtonGroup)(({ theme }) => ({
  paddingBlock: 2,
  [`& .${buttonGroupClasses.grouped}`]: {
    margin: theme.spacing(0.5),
    border: 0,
    borderRadius: theme.shape.borderRadius,
  },
}));

export default function SearchDisplayTypeSelection({
  isMobile,
  resultDisplay,
  setResultDisplay,
}: {
  isMobile: boolean;
  resultDisplay: string;
  setResultDisplay: (display: 'list' | 'gallery' | 'map') => void;
}) {
  const { searchType } = useSearchStore();
  return (
    <ResultToolbarButtonGroup>
      <ResultToolbarButton
        color={resultDisplay === 'list' ? 'info' : 'inherit'}
        sx={{
          height: 48,
          backgroundColor: resultDisplay === 'list' ? blue[50] : 'inherit',
        }}
        variant="outlined"
        value={'list'}
        onClick={() => setResultDisplay('list')}
      >
        <FormatListBulletedIcon />
      </ResultToolbarButton>
      {searchType !== 'member' && (
        <ResultToolbarButton
          color={resultDisplay === 'gallery' ? 'info' : 'inherit'}
          sx={{
            backgroundColor: resultDisplay === 'gallery' ? blue[50] : 'inherit',
          }}
          value={'gallery'}
          onClick={() => setResultDisplay('gallery')}
        >
          <ViewModuleIcon />
        </ResultToolbarButton>
      )}
      {searchType !== 'member' && (
        <ResultToolbarButton
          color={resultDisplay === 'map' ? 'info' : 'inherit'}
          sx={{
            display: 'none',
            backgroundColor: resultDisplay === 'map' ? blue[50] : 'inherit',
          }}
          value={'map'}
          onClick={() => setResultDisplay('map')}
          disabled
        >
          <PlaceIcon />
        </ResultToolbarButton>
      )}
    </ResultToolbarButtonGroup>
  );
}
